import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n' // ✅ 导入VueI18n库
import router from './router'
import './styles/global.css'
Vue.use(VueI18n)

const messages = {
    zh: {
        home: '首页',
        about: '关于我们',
        products: '产品展示',
        news: '新闻资讯',
        contact: '联系我们',
        viewDetails: '查看详情 →',
        backToList: '← 返回产品列表',
        price: '价格',
        category: '分类',
        description: '描述',
        loading: '加载中...',
        error: '出错了',
        notFound: '未找到'
    },
    en: {
        home: 'Home',
        about: 'About Us',
        products: 'Products',
        news: 'News',
        contact: 'Contact',
        viewDetails: 'View Details →',
        backToList: '← Back to Products',
        price: 'Price',
        category: 'Category',
        description: 'Description',
        loading: 'Loading...',
        error: 'Error',
        notFound: 'Not Found'
    }
}

const i18n = new VueI18n({ // ✅ 在这里创建唯一实例
    locale: localStorage.getItem('locale') || 'zh',
    fallbackLocale: 'zh',
    messages
})

Vue.config.productionTip = false

new Vue({
    router,
    i18n, // ✅ 使用这个实例
    render: h => h(App)
}).$mount('#app')